import { render, staticRenderFns } from "./WelcomeQuickSettings.vue?vue&type=template&id=67a1220c&scoped=true"
import script from "./WelcomeQuickSettings.vue?vue&type=script&lang=js"
export * from "./WelcomeQuickSettings.vue?vue&type=script&lang=js"
import style0 from "./WelcomeQuickSettings.vue?vue&type=style&index=0&id=67a1220c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1220c",
  null
  
)

export default component.exports